











































import { defineComponent, useFetch, ref, computed, ssrRef } from '@nuxtjs/composition-api';
import { useFaq } from '@wemade-vsf/faq';
import type { FAQCategory, FAQMeta } from '@wemade-vsf/faq';
import { SfHeading, SfInput, SfAccordion } from '@storefront-ui/vue';
import { getMetaInfo } from '@wemade-vsf/core';

export default defineComponent({
  name: 'Faq',
  components: {
    SfHeading,
    SfInput,
    SfAccordion
  },
  setup () {
    const { loading, loadFaqMeta, loadFaqList } = useFaq()
    const meta = ref<FAQMeta | null>(null)
    const rootCategories = ssrRef<FAQCategory[] | null>(null)
    const title = computed(() => meta.value?.title || '')
    const query = ref('')
    const categories = computed(() => {
      if (query.value.length >= 3 && rootCategories.value) {
        const q = query.value.toLowerCase()
        return rootCategories.value.map(c => {
          return {
            ...c,
            articles: {
              items: c.articles?.items?.length ? c.articles.items.filter(i => {
                return i?.name && i?.article_content ? i.name.toLowerCase().indexOf(q) > -1 || i.article_content.toLowerCase().indexOf(q) > -1 : false
              }) : []
            }
          }
        })
      } else {
        return rootCategories.value
      }
    })

    useFetch (async () => {
      meta.value  = await loadFaqMeta()
      rootCategories.value = await loadFaqList({ filter: { enabled: { eq: '1' } } })
    })


    return {
      loading,
      categories,
      meta,
      title,
      query
    }
  },
  head () {
    return getMetaInfo(this.meta)
  }
})
